import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, CardContent, Grid, Typography } from 'components/ui';
import { CheckIcon } from 'components/uiIcons';
import { PricingCard, PricingBadge, PricingPrice, PricingPeriod, PricingFeatureList, PricingFeatureItem } from 'components/styles_components/pricing';
import { CardOptionTypography } from 'components/styles_components/typography';
import { DividerContainer } from 'components/styles_components/container';
import ChangePlanButton from 'components/space/button/change_plan';

const PlanShow = ({ plan, active, buttonDisabled }) => {
  const isFreePlan = plan.price === 0;
  const showButton = !isFreePlan || !active;
  const isButtonDisabled = buttonDisabled || (!active && !plan.canSet);

  return (
    <Grid size={{ xs: 6, md: 4 }}>
      <PricingCard elevation={0} $highlighted={active}>
        {active && (
          <PricingBadge>
            <FormattedMessage id="plan.current" />
          </PricingBadge>
        )}
        <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
          <CardOptionTypography>
            {plan.name}
          </CardOptionTypography>
          <DividerContainer />
          <PricingPrice>
            {plan.price} PLN / <FormattedMessage id={`plan.period.${plan.billingIntervalType}`} />
            <PricingPeriod>{plan.period}</PricingPeriod>
          </PricingPrice>
          <PricingFeatureList>
            <PricingFeatureItem>
              <CheckIcon />
              <FormattedMessage id="plan.inspections_limit" values={{ limit: plan.inspectionsLimit }} />
            </PricingFeatureItem>
            <PricingFeatureItem>
              <CheckIcon />
              <FormattedMessage id="plan.inspection_subjects_limit" values={{ limit: plan.inspectionSubjectsLimit }} />
            </PricingFeatureItem>
            <PricingFeatureItem>
              <CheckIcon />
              <FormattedMessage id="plan.places_limit" values={{ limit: plan.placesLimit }} />
            </PricingFeatureItem>
          </PricingFeatureList>
          {!active && !plan.canSet && (
            <Typography variant="caption" color="warning" sx={{ mt: 1, textAlign: 'center' }}>
              <FormattedMessage id="plan.limits_exceeded" />
            </Typography>
          )}
          {showButton && (
            <Box sx={{ mt: 'auto', justifyContent: 'center', display: 'flex' }}>
              <ChangePlanButton plan={plan} disabled={isButtonDisabled} active={active} />
            </Box>
          )}
        </CardContent>
      </PricingCard>
    </Grid>
  );
};

export default PlanShow;
